import { fetchJSON } from '@bonnet/next/fetch';

export default (query) => fetchJSON('/cars-for-sale/svc/listing-view-count', { query });
